module.exports = __webpack_public_path__ + "assets/img/mobile_login.236c8fe9.svg";